
export { getDataLayerScriptWithNavigationSupport } from "./utils/tracking/data-layer"